module.exports = __webpack_public_path__ + "img/cloudpod_login_logo.d1bd4ed5.png";